export default __webpack_public_path__ + "static/media/swap.5fffcb9a.svg";